<template>
  <!-- 直接装箱箱子页面 -->
  <div class="direct-packing-box-page">
    <baseBreadcrumb :page="$t('message.directPackingBox')" :menu="$t('message.warehouse')"></baseBreadcrumb>

    <div class="tabs">
      <!-- 箱子状态切换 -->
      <el-tabs v-model="datas.status" type="card" @tab-click="handleTabChange">
        <el-tab-pane v-for="tab in tabs" :key="tab.name" :label="getTabLabel(tab)" :name="tab.name">
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 搜索条件 -->
    <div class="search-area">
      <div class="search-row">
        <!-- 开始日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            value-format="yyyy-MM-dd HH:mm:ss" default-time="00:00:00" />
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59" />
        </div>
        <!-- 客户ID -->
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" clearable />
        </div>
        <!-- 订单号 -->
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" clearable />
        </div>
        <!-- 装箱授权 -->
        <div class="item">
          <el-select v-model="datas.authorized" clearable :placeholder="$t('message.packingAuthorization')">
            <el-option :label="$t('message.unauthorized')" :value="0" />
            <el-option :label="$t('message.haveAuthorized')" :value="1" />
          </el-select>
        </div>
        <!-- 整单是否上架完了 -->
        <div class="item">
          <el-select v-model="datas.is_complete_storage" clearable
            :placeholder="$t('message.wholeOrderShelfCompleted')">
            <el-option :label="$t('message.are')" :value="1" />
            <el-option :label="$t('message.no')" :value="0" />
          </el-select>
        </div>
        <!-- 配送单号 -->
        <div class="item" v-if="['2'].includes(datas.status)">
          <el-input v-model="datas.porder_sn" :placeholder="$t('message.deliveryNoteNumber')" clearable />
        </div>
        <!-- 仓库龄最小值 -->
        <div class="item" v-if="['1', '2'].includes(datas.status)">
          <el-input v-model="datas.storage_days_min" :placeholder="$t('message.warehouseAgeMin')" clearable />
        </div>
        <!-- 仓库龄最大值 -->
        <div class="item" v-if="['1', '2'].includes(datas.status)">
          <el-input v-model="datas.storage_days_max" :placeholder="$t('message.warehouseAgeMax')" clearable />
        </div>
        <!-- 货架类型 -->
        <div class="item" v-if="['1', '2'].includes(datas.status)">
          <el-select v-model="datas.shelf_type" clearable filterable :placeholder="$t('message.shelfType')">
            <el-option :label="$t('message.normalShelf')" value="normal" />
            <el-option :label="$t('message.chargeShelf')" value="charge" />
          </el-select>
        </div>
        <!-- 业务员 -->
        <div class="item">
          <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
            <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id" />
          </el-select>
        </div>
        <!-- 采购员 -->
        <div class="item">
          <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
            <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id" />
          </el-select>
        </div>
        <!-- 配货员 -->
        <div class="item">
          <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id" />
          </el-select>
        </div>
        <!-- 搜索和重置 -->
        <div class="search-buttons">
          <el-button type="primary" @click="handleSearch">{{ $t('message.search') }}</el-button>
          <el-button @click="reset">{{ $t('message.reset') }}</el-button>
        </div>
        <!-- 批量操作按钮 -->
        <div class="action-buttons">
          <template v-if="['1'].includes(datas.status)">
            <!-- 入长存仓库 -->
            <el-button v-if="isAuth(267)" type="primary" class="btn-blue" @click="warehousing">{{
              $t('message.intoLongTermStorageWarehouse') }}</el-button>
            <!-- 退回装箱中 -->
            <el-button type="primary" class="btn-dark" @click="toUnComplete">{{ $t('message.returnToPacking')
            }}</el-button>
            <!-- 生成配送单 -->
            <el-button v-if="isAuth(268)" type="primary" class="btn-blue" @click="boxToPorder">{{
              $t('message.generateDeliveryOrder') }}</el-button>
            <!-- 退回普通仓库 -->
            <el-button v-if="isAuth(266)" type="danger" @click="returnToRegularWarehouse">{{
              $t('message.returnToRegularWarehouse') }}</el-button>
          </template>
          <el-button :disabled="!tableData.length" @click="toggleAllBoxes">
            {{ allBoxesExpanded ? $t('message.oneClickCollapse') : $t('message.oneClickExpand') }}
          </el-button>
        </div>
      </div>
    </div>

    <!-- 订单 / 箱子 / 商品三级列表 -->
    <div class="table-wrap">
      <div class="order-list">
        <!-- 固定箱子列头 -->
        <div class="table-row header-row">
          <div class="cell checkbox-cell">
            <el-popover placement="right" :title="$t('message.total')" width="220" trigger="focus">
              <statistics :checkedList="selectList" />
              <el-checkbox slot="reference" :value="checked" :indeterminate="selectList.length > 0 && !checked"
                @change="allchecked" />
            </el-popover>
          </div>
          <div class="cell no-cell">NO</div>
          <div class="cell box-cell">{{ $t('message.boxNums') }}</div>
          <div class="cell time-cell">{{ $t('message.packTime') }}</div>
          <div class="cell weight-cell">{{ $t('message.actualWeight') }}</div>
          <div class="cell size-cell">{{ $t('message.boxSize') }}(cm)</div>
          <div class="cell status-cell">{{ $t('message.boxStatus') }}</div>
          <div v-if="['0'].includes(datas.status)" class="cell status-cell">{{ $t('message.currentOrderStatus') }}</div>
          <div v-if="['1'].includes(datas.status)" class="cell location-cell">{{ $t('message.locationInfo') }}</div>
          <div v-if="['1'].includes(datas.status)" class="cell time-cell">{{ $t('message.packCompleteInboundTime') }}
          </div>
          <div v-if="['2'].includes(datas.status)" class="cell time-cell">{{ $t('message.inboundDate') }}</div>
          <div v-if="['2'].includes(datas.status)" class="cell time-cell">{{ $t('message.outboundDate') }}</div>
          <div v-if="['2'].includes(datas.status)" class="cell porder-cell">{{ $t('message.belongingPorder') }}</div>
          <div v-if="['1', '2'].includes(datas.status)" class="cell age-cell">{{ $t('message.warehouseAge') }}</div>
          <div v-if="['1', '2'].includes(datas.status)" class="cell amount-cell">{{ $t('message.boxInnerGoodsValue') }}
          </div>
          <div v-if="['2'].includes(datas.status)" class="cell fee-cell">{{ $t('message.warehouseFeePaid') }}</div>
          <div v-if="['2'].includes(datas.status)" class="cell remark-cell">{{ $t('message.customerOrderRemark') }}
          </div>
          <div class="cell remark-cell">{{ $t('message.distributionPackRemark') }}</div>
          <div class="cell remark-cell">{{ $t('message.salesPackRemark') }}</div>
        </div>

        <div v-for="(orderItem, orderIndex) in tableData" :key="orderItem.order_sn" class="order-group">
          <!-- 第一层：订单分组条 -->
          <div class="order-head">
            <button class="order-toggle" @click="toggleOrder(orderItem)">
              <i :class="orderItem.show ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
            </button>
            <div class="order-select">
              <el-popover placement="right" :title="$t('message.total')" width="220" trigger="focus">
                <statistics :checkedList="selectList" />
                <el-checkbox slot="reference" :value="orderItem.boxes.length > 0 && orderItem.boxes.every(box => box.checked)"
                  :indeterminate="orderItem.boxes.some(box => box.checked) && !orderItem.boxes.every(box => box.checked)"
                  @change="changeItem(orderItem, $event)" />
              </el-popover>
            </div>
            <div class="order-head-item order-main">
              <div class="order-main-line">
                <span class="order-head-label">{{ $t('message.orderNumber') }}：</span>
                <router-link v-if="orderItem.order_sn" class="order-number"
                  :to="`/orderPaymentDetail?order_sn=${orderItem.order_sn}`" target="_blank">
                  {{ orderItem.order_sn }}
                </router-link>
                <span v-else>-</span>
              </div>
              <div class="order-main-line order-customer">
                <span class="authorization-badge" :class="{ authorized: orderItem.is_authorized == 1 }">
                  {{ orderItem.authorized_name || (orderItem.is_authorized == 1 ? $t('message.haveAuthorized') :
                    $t('message.unauthorized')) }}
                </span>
                <router-link v-if="orderItem.user_id"
                  :to="'/user/basicInformation?userID=' + orderItem.user_id + '&encryption=' + $md5(orderItem.user_id + '')"
                  target="_blank">
                  {{ orderItem.user_realname || orderItem.user_id }}
                </router-link>
              </div>
            </div>
            <div class="order-head-item order-attribute">
              <span class="order-head-label">{{ $t('message.customerProperty') }}：</span>
              <div style="width: 80px;">
                <attributeName :name="orderItem.client_attribute.name" />
              </div>

            </div>
            <div class="order-head-item order-statistics">
              <div>{{ $t('message.boxNum') }}：{{ orderItem.box_count }}</div>
              <div>{{ $t('message.totalWeight') }}：{{ orderItem.total_weight }}kg</div>
            </div>
            <div class="order-head-item order-time">
              <div class="order-head-label">{{ $t('message.customerPaymentTime') }}</div>
              <div>{{ orderItem.datetime_pay_confirm || '-' }}</div>
            </div>
            <div v-if="orderItem.datetime_up_complete" class="order-head-item order-time">
              <div class="order-head-label">
                {{ $t('message.shelfCompletionTime') }}
                <span class="shelf-complete-label">（{{ $t('message.shelfCompletedLabel') }}）</span>
              </div>
              <div class="shelf-complete-time">{{ orderItem.datetime_up_complete }}</div>
            </div>
            <div class="order-head-item order-admin">
              <span class="order-head-label">{{ $t('message.business') }}：</span>{{ orderItem.y_admin_name || '-' }}
            </div>
            <div class="order-head-item order-admin">
              <span class="order-head-label">{{ $t('message.purchase') }}：</span>{{ orderItem.g_admin_name || '-' }}
            </div>
            <div class="order-head-item order-admin">
              <span class="order-head-label">{{ $t('message.distribution') }}：</span>{{ orderItem.p_admin_name || '-' }}
            </div>
          </div>

          <div v-if="orderItem.show" class="box-level">
            <div v-for="(box, boxIndex) in orderItem.boxes" :key="box.id" class="box-group">
              <!-- 第二层：箱子 -->
              <div class="table-row box-row">
                <div class="cell checkbox-cell">
                  <el-popover placement="right" :title="$t('message.total')" width="220" trigger="focus">
                    <statistics :checkedList="selectList" />
                    <el-checkbox slot="reference" v-model="box.checked" @change="changeItem" />
                  </el-popover>
                </div>
                <div class="cell no-cell">{{ getRowNo(orderIndex) }}-{{ boxIndex + 1 }}</div>
                <div class="cell box-cell">
                  <router-link v-if="box.id" :to="`/boxDetail?id=${box.id}&verification=${$md5(box.id + '')}`"
                    target="_blank" class="box-no">
                    {{ box.box_no || '-' }}
                  </router-link>
                  <span v-else>{{ box.box_no || '-' }}</span>
                  <p> 箱ID:{{ box.id }}</p>
                  <button class="expand-btn" @click="toggleRow(box)">
                    {{ box.show ? $t('message.collapse') : $t('message.expand') }}
                    <i class="small-arrow" :class="{ up: box.show }"></i>
                  </button>
                </div>
                <div class="cell time-cell multiline">
                  <template v-if="box.created_at">
                    {{ splitDateTime(box.created_at).date }}<br>{{ splitDateTime(box.created_at).time }}
                  </template>
                  <template v-else>-</template>
                </div>
                <div class="cell weight-cell">{{ box.weight != null ? box.weight : '-' }}</div>
                <div class="cell size-cell">{{ formatBoxSize(box) }}</div>
                <div class="cell status-cell">{{ box.status_name || '-' }}</div>
                <div v-if="['0'].includes(datas.status)" class="cell status-cell">
                  {{ box.order_status_name || '-' }}
                </div>
                <div v-if="['1'].includes(datas.status)" class="cell location-cell location-text multiline">
                  <template v-if="box.grid_number">
                    <span :class="isChargeShelf(box) ? 'location-charge' : 'location-normal'">
                      {{ isChargeShelf(box) ? $t('message.longTermStorageWarehouse') : $t('message.normalShelf') }}
                    </span><br>{{ box.grid_number }}
                  </template>
                  <template v-else>-</template>
                </div>
                <div v-if="['1'].includes(datas.status)" class="cell time-cell multiline">
                  <template v-if="box.complete_at || box.inbound_at">
                    {{ splitDateTime(box.complete_at || box.inbound_at).date }}<br>
                    {{ splitDateTime(box.complete_at || box.inbound_at).time }}
                  </template>
                  <template v-else>-</template>
                </div>
                <div v-if="['2'].includes(datas.status)" class="cell time-cell multiline">
                  <template v-if="box.inbound_at">
                    {{ splitDateTime(box.inbound_at).date }}<br>{{ splitDateTime(box.inbound_at).time }}
                  </template>
                  <template v-else>-</template>
                </div>
                <div v-if="['2'].includes(datas.status)" class="cell time-cell multiline">
                  <template v-if="box.outbound_at">
                    {{ splitDateTime(box.outbound_at).date }}<br>{{ splitDateTime(box.outbound_at).time }}
                  </template>
                  <template v-else>-</template>
                </div>
                <div v-if="['2'].includes(datas.status)" class="cell porder-cell">
                  <router-link v-if="box.porder_sn" :to="`/porderDetail?porder_sn=${box.porder_sn}`" target="_blank"
                    class="box-no">{{
                      box.porder_sn }}</router-link>
                  <span v-else>-</span>
                </div>
                <div v-if="['1', '2'].includes(datas.status)" class="cell age-cell">
                  {{ box.storage_days != null ? box.storage_days : '-' }}
                </div>
                <div v-if="['1', '2'].includes(datas.status)" class="cell amount-cell">
                  {{ box.goods_value != null ? box.goods_value : '-' }}
                </div>
                <div v-if="['2'].includes(datas.status)" class="cell fee-cell">
                  {{ box.total_storage_fee != null ? box.total_storage_fee : '-' }}
                </div>
                <div v-if="['2'].includes(datas.status)" class="cell remark-cell multiline">
                  {{ box.customer_remark || '-' }}
                </div>
                <div class="cell remark-cell multiline">
                  <el-input v-model="box.p_remark" type="textarea" @blur="updatePRemark(box, 'p')"
                    :disabled="remarkData.remark_type != 5" />
                </div>
                <div class="cell remark-cell multiline">
                  <el-input v-model="box.y_remark" type="textarea" @blur="updatePRemark(box, 'y')"
                    :disabled="remarkData.remark_type != 1" />
                </div>
              </div>

              <!-- 第三层：商品 -->
              <div v-if="box.show" class="goods-detail">
                <div class="goods-row goods-header">
                  <div class="goods-cell order">{{ $t('message.orderNumberMash') }}</div>
                  <div class="goods-cell sort">{{ $t('message.mash') }}</div>
                  <div class="goods-cell attr">{{ $t('message.commodityAttribute') }}</div>
                  <div class="goods-cell img">{{ $t('message.picture') }}</div>
                  <div class="goods-cell num">{{ $t('message.quantity') }}</div>
                </div>
                <div v-for="(goods, goodsIndex) in box.order_detail_list" :key="goodsIndex" class="goods-row">
                  <div class="goods-cell order">
                    <router-link v-if="goods.order_sn" :to="`/orderPaymentDetail?order_sn=${goods.order_sn}`"
                      target="_blank" class="box-no">{{ goods.order_sn }}</router-link>
                    <span v-else>-</span>
                  </div>
                  <div class="goods-cell sort">{{ goods.sorting }}</div>
                  <div class="goods-cell attr">
                    <p v-for="(attr, attrIndex) in goods.detail_y" :key="attrIndex">{{ attr.key }}:{{ attr.value }}</p>
                    <span v-if="!goods.detail_y || !goods.detail_y.length">-</span>
                  </div>
                  <div class="goods-cell img">
                    <el-popover v-if="goods.pic" placement="right" width="300" trigger="hover">
                      <el-image :src="goods.pic" style="width: 300px; height: 300px;" />
                      <el-image slot="reference" :src="goods.pic" fit="fill" style="width: 60px; height: 60px;" />
                    </el-popover>
                    <div v-else class="goods-img"></div>
                  </div>
                  <div class="goods-cell num">{{ goods.num }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 30, 50]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 提出配送单确认弹框 -->
      <el-dialog title="提出配送单" :visible.sync="boxToPorderDialogVisible" width="380px" center
        :show-close="!boxToPorderSubmitting" :close-on-click-modal="!boxToPorderSubmitting"
        :close-on-press-escape="!boxToPorderSubmitting">
        <div class="content">
          <div class="toPorderList">
            <p>当前共选择以下客户的箱子，确认后将按照客户生成不同的配送单，请确认后操作。</p>
            <div class="to-porder-user-list">
              <p v-for="group in boxToPorderGroups" :key="group.user_id">
                ID：{{ group.user_id }} {{ group.user_name }} 已选{{ group.boxIds.length }}箱
              </p>
            </div>
          </div>
          <div v-if="boxToPorderSubmitting || boxToPorderProgress.current" class="to-porder-progress">
            <div class="progress-text">
              配送单生成进度：{{ boxToPorderProgress.current }}/{{ boxToPorderProgress.total }}
            </div>
            <el-progress :percentage="boxToPorderProgressPercent"></el-progress>
          </div>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button type="primary" :loading="boxToPorderSubmitting" @click="submitBoxToPorder">确定</el-button>
          <el-button :disabled="boxToPorderSubmitting" @click="boxToPorderDialogVisible = false">取消</el-button>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import statistics from './statistics'

export default {
  name: 'DirectPackingBox',
  components: {
    statistics
  },
  data() {
    return {
      checked: false,
      datas: this.getDefaultSearch(),
      total: 0,
      // 箱子状态：'' 全部不传，0 装箱中，1 装箱完成待出货，2 已出货
      tabs: [
        // { name: 'all', labelKey: 'all', count: 0 },
        { name: '0', labelKey: 'thePacking', count: 0, value: 'un_complete' },
        { name: '1', labelKey: 'packCompleteWaitShip', count: 0, value: 'completed' },
        { name: '2', labelKey: 'shipped', count: 0, value: 'porder' }
      ],
      tableData: [],
      selectList: [],
      remarkData: {
        remark_type: localStorage.getItem("japanUserRoleStatus")
      },
      boxIds: [],
      boxToPorderDialogVisible: false,
      boxToPorderSubmitting: false,
      boxToPorderGroups: [],
      boxToPorderProgress: {
        current: 0,
        total: 0
      }
    }
  },
  computed: {
    allBoxesExpanded() {
      return this.tableData.length > 0 && this.tableData.every(order => order.show && order.boxes.every(box => box.show))
    },
    boxToPorderProgressPercent() {
      if (!this.boxToPorderProgress.total) return 0
      return Math.round((this.boxToPorderProgress.current / this.boxToPorderProgress.total) * 100)
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y
    },
    g() {
      return this.$store.state.authWorkGroupAdmin.g
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p
    }
  },
  created() {
    if (this.$route.query.status) {
      this.datas.status = this.$route.query.status
    }
    this.getTabCount()
    this.getList()
  },
  methods: {
    // 初始化搜索条件
    getDefaultSearch() {
      return {
        dateStart: '',
        dateEnd: '',
        status: '0',
        user_id: '',
        porder_sn: '',
        order_sn: '',
        authorized: '',
        is_complete_storage: '',
        y_id: '',
        g_id: '',
        p_id: '',
        storage_days_min: '',
        storage_days_max: '',
        shelf_type: '',
        page: 1,
        pageSize: 10
      }
    },
    // 获取直接装箱箱子列表
    getList() {

      const params = {
        page: this.datas.page,
        pageSize: this.datas.pageSize
      }
        // 只传有值的筛选项，避免空字符串影响后端筛选
        ;[
          'status',
          'dateStart',
          'dateEnd',
          'user_id',
          'porder_sn',
          'order_sn',
          'authorized',
          'is_complete_storage',
          'y_id',
          'g_id',
          'p_id',
          'storage_days_min',
          'storage_days_max',
          'shelf_type'
        ].forEach(key => {
          if (this.datas[key] !== '' && this.datas[key] != null) {
            params[key] = this.datas[key]
          }
        })

      this.$api.porderApi.listV2(params).then(res => {
        this.setTableData(res.data || {})
      })
    },
    // 获取直接装箱列表 Tab 数量
    getTabCount() {
      const params = {}
      const countFilterKeys = [
        'dateStart',
        'dateEnd',
        'user_id',
        'porder_sn',
        'order_sn',
        'authorized',
        'is_complete_storage',
        'y_id',
        'g_id',
        'p_id',
        'storage_days_min',
        'storage_days_max',
        'shelf_type'
      ]
      // 统计数量只传筛选条件，不传当前 Tab 状态和分页参数
      countFilterKeys.forEach(key => {
        if (this.datas[key] !== '' && this.datas[key] != null) {
          params[key] = this.datas[key]
        }
      })

      this.$api.porderApi.boxTabCountV2(params).then(res => {
        const data = res.data || {}
        this.tabs.forEach(tab => {
          this.$set(tab, 'count', this.getTabCountValue(data, tab.value))
        })
      })
    },
    // 兼容接口返回对象或数组两种格式
    getTabCountValue(data, value) {
      if (Array.isArray(data)) {
        const item = data.find(row => String(row.value) === String(value) || String(row.name) === String(value))
        return item ? (item.count || item.total || 0) : 0
      }
      return data[value] || 0
    },
    // V2 列表按订单分页，每个订单下包含箱子，箱子下包含商品
    setTableData(data) {
      const list = data.data || []
      this.tableData = list.map(order => ({
        ...order,
        show: true,
        boxes: order.boxes.map(box => ({
          ...box,
          show: false,
          checked: false,
          order_status_name: box.order && box.order.status_name,
          customer_remark: box.order && box.order.client_remark
        }))
      }))
      this.total = data.total || 0
      this.checked = false
      this.selectList = []
    },
    // 计算分页序号
    getRowNo(index) {
      return (this.datas.page - 1) * this.datas.pageSize + index + 1
    },
    // 格式化箱规：优先使用接口返回的 attr
    formatBoxSize(item) {
      if (item.c == null && item.k == null && item.g == null) return '-'
      return  `${item.c || 0}*${item.k || 0}*${item.g || 0}`
    },
    // 拆分日期和时间，用于表格换行显示
    splitDateTime(datetime) {
      if (!datetime) return { date: '', time: '' }
      const [date, time] = datetime.split(' ')
      return { date: date || '', time: time || '' }
    },
    // 获取客户姓名
    getUserName(item) {
      const user = (item.order && item.order.user) || item.user || {}
      return user.realname || item.user_name || '-'
    },
    // 获取客户ID
    getUserId(item) {
      return (item.order && item.order.user_id) || (item.order && item.order.user && item.order.user.id) || item.user_id || '-'
    },
    // 获取多语言文案
    getMessage(key) {
      return this.$t(`message.${key}`)
    },
    // 拼接 Tab 名称和数量
    getTabLabel(tab) {
      return `${this.getMessage(tab.labelKey)}(${tab.count})`
    },
    // 切换箱子状态 Tab
    handleTabChange() {
      this.datas.page = 1
      this.getList()
    },
    // 搜索列表
    handleSearch(resetPage = true, refreshCount = true) {
      if (resetPage) {
        this.datas.page = 1
      }
      if (refreshCount) {
        this.getTabCount()
      }
      this.getList()
    },
    // 切换页码
    handleCurrentChange(val) {
      this.datas.page = val
      this.handleSearch(false, false)
    },
    // 切换每页条数
    handleSizeChange(val) {
      this.datas.pageSize = val
      this.datas.page = 1
      this.handleSearch(true, false)
    },
    // 重置搜索条件
    reset() {
      this.datas = this.getDefaultSearch()
      this.handleSearch()
    },
    // 表头全选只操作当前页的箱子。
    allchecked(checked) {
      this.tableData.forEach(order => {
        order.boxes.forEach(box => {
          box.checked = checked
        })
      })
      this.changeItem()
    },
    // 同步当前选中的箱子和表头状态。
    changeItem(order, checked) {
      if (order && order.boxes) {
        order.boxes.forEach(box => {
          box.checked = checked
        })
      }
      this.selectList = this.tableData.reduce((list, order) => {
        return list.concat(order.boxes.filter(box => box.checked))
      }, [])
      this.checked = this.selectList.length > 0 && this.tableData.every(order => order.boxes.every(box => box.checked))
    },
    // 校验是否已选择可操作箱子
    validateSelected() {
      if (!this.selectList.length) {
        this.$message.error(this.$t("message.selectableOperational"))
        return false
      }
      this.boxIds = this.selectList.map(item => item.id)
      return true
    },
    // 获取箱子当前库位所属货架类型
    getShelfType(item) {
      return item.shelf_type || (item.wms_grid && item.wms_grid.wms_shelf && item.wms_grid.wms_shelf.shelf_type) || ''
    },
    // 判断是否普通仓库货架
    isNormalShelf(item) {
      return ['1', 'normal'].includes(String(this.getShelfType(item)))
    },
    // 判断是否长存仓库货架
    isChargeShelf(item) {
      return ['4', 'charge'].includes(String(this.getShelfType(item)))
    },
    // 校验选中箱子必须属于普通仓库货架
    validateNormalShelfSelected() {
      if (!this.validateSelected()) return false
      if (this.selectList.some(item => this.isChargeShelf(item))) {
        this.$message.error('当前商品箱子存放在长存仓库，无法操作，请从长存仓库取出后，在重新操作。')
        return false
      }
      return true
    },
    // 校验选中箱子必须属于长存仓库货架
    validateChargeShelfSelected() {
      if (!this.validateSelected()) return false
      if (this.selectList.some(item => !this.isChargeShelf(item))) {
        this.$message.error('只能操作当前库位属于长存仓库货架的箱子')
        return false
      }
      return true
    },
    // 二次确认批量操作
    confirmAction(message) {
      return this.$confirm(
        message,
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
    },
    // 入长存仓库：普通仓库箱子生成等待放入长存仓库的转库单
    warehousing() {
      if (!this.validateNormalShelfSelected()) return
      const params = {
        boxIds: this.boxIds
      }
      this.confirmAction('商品确定转入长存仓库吗，转入长存仓库后，系统将自动根据该箱子在仓库的体积进行收费！')
        .then(() => {
          this.$api.inventoryTransferApi.applyToCharge(params).then(res => {
            this.$message.success(res.msg)
            this.getTabCount()
            this.getList()
          })
        })
        .catch(() => { })
    },
    // 退回常规仓库：长存仓库箱子生成等待取出的转库单
    returnToRegularWarehouse() {
      if (!this.validateChargeShelfSelected()) return
      const params = {
        boxIds: this.boxIds
      }
      this.confirmAction('确认将选中的箱子退回常规仓库？')
        .then(() => {
          this.$api.inventoryTransferApi.returnToNormal(params).then(res => {
            this.$message.success(res.msg)
            this.getTabCount()
            this.getList()
          })
        })
        .catch(() => { })
    },
    // 退回装箱中
    toUnComplete() {
      if (!this.validateNormalShelfSelected()) return
      const params = {
        ids: this.boxIds
      }
      this.confirmAction('确认将选中的箱子退回装箱中？退回后会清除装箱完成时间。')
        .then(() => {
          this.$api.inspectionApi.toUnComplete(params).then(res => {
            this.$message.success(res.msg)
            this.getTabCount()
            this.getList()
          })
        })
        .catch(() => { })
    },
    // 生成配送单
    boxToPorder() {
      if (!this.validateNormalShelfSelected()) return
      this.boxToPorderGroups = this.groupSelectedBoxesByUser()
      this.boxToPorderProgress = {
        current: 0,
        total: this.boxToPorderGroups.length
      }
      this.boxToPorderDialogVisible = true
    },
    // 按客户分组选中的箱子
    groupSelectedBoxesByUser() {
      const groupMap = {}
      this.selectList.forEach(item => {
        const userId = this.getUserId(item)
        const key = String(userId)
        if (!groupMap[key]) {
          groupMap[key] = {
            user_id: userId,
            user_name: this.getUserName(item),
            boxIds: [],
            done: false,
            porder_sn: ''
          }
        }
        groupMap[key].boxIds.push(item.id)
      })
      return Object.keys(groupMap).map(key => groupMap[key])
    },
    // 提交配送单：按客户逐个生成，弹框中展示进度
    async submitBoxToPorder() {
      if (this.boxToPorderSubmitting || !this.boxToPorderGroups.length) return
      this.boxToPorderSubmitting = true
      const finishedCount = this.boxToPorderGroups.filter(group => group.done).length
      this.boxToPorderProgress = {
        current: finishedCount,
        total: this.boxToPorderGroups.length
      }
      try {
        for (const group of this.boxToPorderGroups) {
          if (group.done) continue
          const res = await this.$api.porderApi.boxToPorder({ boxIds: group.boxIds })
          if (res && res.data) {
            this.$set(group, 'porder_sn', res.data)
          }
          this.$set(group, 'done', true)
          this.boxToPorderProgress.current += 1
        }
        const porderSns = this.boxToPorderGroups.map(group => group.porder_sn).filter(Boolean)
        this.$message.success(`配送单生成成功，共${porderSns.length || this.boxToPorderGroups.length}个`)
        this.boxToPorderDialogVisible = false
        this.boxToPorderSubmitting = false
        porderSns.forEach(porderSn => {
          this.openPorderDetail(porderSn)
        })
        this.getTabCount()
        this.getList()
      } catch (error) {
        this.$message.error((error && (error.msg || error.message)) || '配送单生成失败')
        this.boxToPorderSubmitting = false
      }
    },
    // 打开配送单详情
    openPorderDetail(porderSn) {
      const url = this.$router.resolve({
        name: "porderDetail",
        query: {
          porder_sn: porderSn
        }
      })
      window.open(url.href, "_blank")
    },
    // 备注失焦保存：配货备注 p_remark，业务备注 y_remark
    updatePRemark(item, type) {
      const params = {
        box_id: item.id
      }
      if (type === 'p') {
        params.p_remark = item.p_remark
        this.$api.inspectionApi.updatePRemark(params)
      } else {
        params.y_remark = item.y_remark
        this.$api.inspectionApi.updateYRemark(params)
      }
    },
    // 一键展开时同步打开订单分组，收起时保留箱子列表。
    toggleAllBoxes() {
      const show = !this.allBoxesExpanded
      this.tableData.forEach(order => {
        if (show) order.show = true
        order.boxes.forEach(box => {
          box.show = show
        })
      })
    },
    // 展开或收起箱内商品明细
    toggleRow(item) {
      item.show = !item.show
    },
    // 展开或收起订单下的箱子
    toggleOrder(order) {
      order.show = !order.show
    }
  }
}
</script>

<style lang="scss" scoped>
.direct-packing-box-page {
  width: 100%;
  min-height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background: #f8f8f8;
  color: #333;
  font-family: "Source Han Sans SC", "Microsoft YaHei", Arial, sans-serif;
  font-size: 14px;
}

.tabs {
  margin-bottom: 20px;
  width: 100%;
}

.search-area {
  width: 100%;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
  }

  .item {

    min-width: 0;
    max-width: 100%;

    .el-input,
    .el-select,
    .el-date-editor {
      width: 200px;
    }
  }
}

.small-arrow {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-left: 6px;
  border-right: 1px solid #909399;
  border-bottom: 1px solid #909399;
  transform: rotate(45deg);

  &.up {
    margin-top: 4px;
    transform: rotate(225deg);
  }
}

.search-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex: 1 1 auto;
  gap: 10px;

  .btn-blue {
    border-color: #2c96e7;
    background: #2c96e7;
  }

  .btn-dark {
    border-color: #333;
    background: #333;
  }
}

.table-wrap {
  width: 100%;
  border-radius: 4px;

}

.paginationContainer {
  width: 100%;
  margin-top: 20px;
}

.order-list {
  width: 100%;
  background: #fff;
}

.order-head {
  display: grid;
  grid-template-columns: 34px 34px minmax(230px, 2.1fr) minmax(120px, 1fr) minmax(105px, 0.8fr) minmax(145px, 1.15fr) minmax(145px, 1.15fr) minmax(90px, 0.7fr) minmax(90px, 0.7fr) minmax(90px, 0.7fr);
  align-items: center;
  min-height: 60px;
  margin: 6px 0 0;
  padding: 6px 8px;
  box-sizing: border-box;
  background: #545467;
  color: #fff;
  font-size: 13px;

  a {
    color: #fff;
    text-decoration: underline;
  }
}

.order-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 3px;
  background: #353548;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

.order-select {
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-head-item {
  min-width: 0;
  padding: 0 8px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  a {
    display: inline;
  }
}

.order-head-label {
  color: #e7e8ee;
}

.order-main-line {
  overflow: hidden;
  text-overflow: ellipsis;
}

.order-customer {
  display: flex;
  align-items: center;
  gap: 6px;

  a {
    overflow: hidden;
    color: #fff;
    text-decoration: none;
    text-overflow: ellipsis;
  }
}

.order-number {
  color: #dbe93c !important;
  font-weight: 700;
}

.authorization-badge {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  height: 18px;
  padding: 0 5px;
  border-radius: 4px;
  background: #77788a;
  color: #fff;
  font-size: 10px;
  line-height: 18px;

  &.authorized {
    background: #409eff;
  }
}

.order-attribute,
.order-admin {
  display: flex;
  align-items: center;
}

.order-statistics,
.order-time {
  color: #fff;
}

.shelf-complete-time {
  color: #dbe93c;
  font-weight: 700;
}

.shelf-complete-label {
  color: #ff3b30;
  font-weight: 700;
}

.box-level,
.box-group {
  width: 100%;
}

.table-row {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 138px;
  padding: 20px 0;
  border-bottom: 1px solid #dcdfe6;
  box-sizing: border-box;
  position: relative;

}

.header-row {
  min-height: 56px;
  padding: 0;
  background: #edeff4;
  color: #666;
  font-weight: 700;
  line-height: 18px;
  position: sticky;
  top: 0;
  z-index: 20;
}

.cell {
  flex: 1;
  box-sizing: border-box;
  padding: 0 6px;
  text-align: center;
  line-height: 20px;
  word-break: break-all;
  min-width: 0;
}

.checkbox-cell {
  flex: 0 0 60px;
  padding: 0 8px;
}

.no-cell {
  flex: 0 0 60px;
}

.operator-cell {
  flex: 1.1 1 0;
  min-width: 0;
}

.order-cell {
  flex: 1.4 1 0;
  min-width: 0;
  text-align: left;
}

.box-cell {
  flex: 1 1 0;
  min-width: 0;
}

.time-cell {
  flex: 1 1 0;
  min-width: 0;
}

.weight-cell {
  flex: 0.7 1 0;
  min-width: 0;
}

.size-cell,
.status-cell {
  flex: 0.9 1 0;
  min-width: 0;
}

.location-cell,
.remark-cell,
.porder-cell {
  flex: 1.2 1 0;
  min-width: 0;
}

.age-cell,
.amount-cell,
.fee-cell {
  flex: 0.9 1 0;
  min-width: 0;
}

.checkbox {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
}

.multiline {

  line-height: 22px;
}

.box-no {
  display: block;
  color: #b4272d;
  text-decoration: underline;
  line-height: 20px;
  cursor: pointer;
}

.user-name {
  margin-top: 4px;
  color: #333;
}

.expand-btn {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 60px;
  height: 24px;
  margin-top: 7px;
  padding: 0 6px;
  border: 0;
  border-radius: 4px;
  color: #999;
  background: #f6f6f6;
  font-size: 12px;
  cursor: pointer;
}

.location-text {
  .location-charge {
    color: #b4272d;
  }

  .location-normal {
    color: #333;
  }
}

.goods-detail {
  width: 100%;
}

.goods-row {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 84px;
  padding: 12px 2%;
  border-bottom: 1px solid #dcdfe6;
  background: #fff;
  box-sizing: border-box;

  &.goods-header {
    min-height: 56px;
    padding: 0 2%;
    background: #dcdfe6;
    color: #666;
    font-weight: 700;
  }
}

.goods-cell {
  flex: 1 1 0;
  text-align: center;
  line-height: 22px;
  min-width: 0;
  word-break: break-all;

  &.order {
    flex: 2 1 0;
  }

  &.sort {
    flex: 0.5 1 0;
  }

  &.attr {
    flex: 2 1 0;
  }

  &.img {
    flex: 0.8 1 0;
  }

  &.num {
    flex: 0.5 1 0;
  }
}

.goods-img {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  background: #d8d8d8;
}

.toPorderList {
  padding: 12px;
  margin-top: 12px;
  background-color: #F6F6F6;
  line-height: 24px;
  color: #666;

  p {
    margin: 0;
  }

  .to-porder-user-list {
    margin-top: 20px;
    color: #333;
  }
}

.to-porder-progress {
  margin-top: 16px;

  .progress-text {
    margin-bottom: 8px;
    color: #333;
    line-height: 20px;
  }
}

/deep/.el-textarea__inner {
  height: 100px;
  padding: 5px;
  font-size: 14px !important;
}
</style>
